import React, { useEffect, useRef } from 'react';
import './ConstellationField.css';

const ConstellationField = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d', { alpha: true });
    let animationFrameId;
    let time = 0;
    let scrollPosition = 0;

    // Handle scroll events
    const handleScroll = () => {
      scrollPosition = window.scrollY;
    };

    const drawWave = (yOffset, amplitude, frequency, speed, color) => {
      ctx.beginPath();
      ctx.moveTo(0, canvas.height / 2);

      for (let x = 0; x < canvas.width; x++) {
        const y = Math.sin(x * frequency + time * speed + scrollPosition * 0.002) * amplitude;
        const heightOffset = (Math.sin(time * 0.5) + 1) * 20; // Breathing effect
        
        // Create multiple layers of waves
        ctx.lineTo(
          x, 
          canvas.height / 2 + y + yOffset + heightOffset
        );
      }

      // Create gradient for each wave
      const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
      gradient.addColorStop(0, `rgba(37, 3, 255, 0)`);
      gradient.addColorStop(0.5, color);
      gradient.addColorStop(1, `rgba(37, 3, 255, 0)`);

      ctx.strokeStyle = gradient;
      ctx.lineWidth = 2;
      ctx.stroke();
    };

    const createDataPoint = (x, y) => {
      ctx.beginPath();
      ctx.arc(x, y, 3, 0, Math.PI * 2);
      ctx.fillStyle = '#2503ff';
      ctx.fill();

      // Add glow effect
      ctx.beginPath();
      ctx.arc(x, y, 6, 0, Math.PI * 2);
      const gradient = ctx.createRadialGradient(x, y, 0, x, y, 6);
      gradient.addColorStop(0, 'rgba(37, 3, 255, 0.3)');
      gradient.addColorStop(1, 'rgba(37, 3, 255, 0)');
      ctx.fillStyle = gradient;
      ctx.fill();
    };

    const animate = () => {
      // Clear the canvas with full transparency
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      // Draw waves with existing opacity
      drawWave(0, 30, 0.02, 1, 'rgba(37, 3, 255, 0.2)');
      drawWave(-20, 20, 0.03, 1.5, 'rgba(37, 3, 255, 0.3)');
      drawWave(20, 25, 0.015, 0.7, 'rgba(37, 3, 255, 0.4)');

      // Add data points
      for (let x = 0; x < canvas.width; x += 100) {
        const y = Math.sin(x * 0.02 + time) * 30;
        createDataPoint(x, canvas.height / 2 + y);
      }

      time += 0.015;
      animationFrameId = requestAnimationFrame(animate);
    };

    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = 500;
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);
    handleResize();
    animate();

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return <canvas ref={canvasRef} className="constellation-field" />;
};

export default ConstellationField; 